import { render, staticRenderFns } from "./CategoryCardMain.vue?vue&type=template&id=78f8c225&"
import script from "./CategoryCardMain.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CategoryCardMain.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports